import { getApiBaseUrl, getApiKey } from 'fake-db/apiConfig'
import Mock from '../mock'
import axios from 'axios.js'
let savedZones = []

Mock.onPost('/api/map/zones/import').reply(async (config) => {
    let backendData = null
    try {
        const data = JSON.parse(config.data || '{}')
        const zones = data?.zones || []
        const apiUrl = getApiBaseUrl()
        const apiKey = getApiKey()
        const accessToken = localStorage.getItem('accessToken')
        // Пробрасываем на бэк, если доступен. Если упало — даём ошибку, чтобы видно было.
        const resp = await axios.post(
            `${apiUrl}/map/zones/import/?apiKey=${apiKey}`,
            { zones, accessToken },
            accessToken
                ? { headers: { Authorization: `Bearer ${accessToken}` } }
                : undefined
        )
        backendData = resp?.data || null
        const status = resp?.status || 200
        const asString = typeof resp?.data === 'string' ? resp.data : ''
        if (status >= 400 || asString.toLowerCase().includes('fatal error')) {
            throw new Error(asString || `Backend error: HTTP ${status}`)
        }
        const backendZones =
            resp?.data?.mapSettings?.deliveryZones ||
            resp?.data?.data?.mapSettings?.deliveryZones ||
            resp?.data?.data?.deliveryZones
        savedZones = backendZones || zones
        const basePayload = backendData && typeof backendData === 'object'
            ? backendData
            : { result: 'success' }
        const mapSettings =
            backendData?.mapSettings ||
            backendData?.data?.mapSettings || { deliveryZones: savedZones }
        if (!mapSettings.deliveryZones) {
            mapSettings.deliveryZones = savedZones
        }
        return [200, { ...basePayload, mapSettings }]
    } catch (err) {
        console.error(err)
        const msg =
            err?.response?.data?.message ||
            err?.response?.data ||
            err?.message ||
            'Ошибка сохранения зон'
        return [500, { message: String(msg) }]
    }
})
